/* eslint new-cap: ["error", { "capIsNewExceptions": ["HOC"] }] */
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { HOC } from 'formsy-react';
import { Input } from 'semantic-ui-react';
import formsyProps from '../FormsyProps';
import styles from '../FloatingLabelInput/FloatingLabelInput.scss';

const InputElement = class InputElement extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    setValue: PropTypes.func,
    getValue: PropTypes.func,
    showError: PropTypes.func,
    hasValue: PropTypes.func,
    label: PropTypes.string,
    name: PropTypes.string.isRequired,
    validationError: PropTypes.string,
    required: PropTypes.bool,
    submitted: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };

  constructor(props) {
    super(props);
    this.state = {
      initialBlur: false
    };
    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // Ties `value` field to HOC value functions
    if (nextProps.value && nextProps.value !== this.props.getValue()) {
      this.props.setValue(nextProps.value);
      this.setState({ isActive: nextProps.value !== null && nextProps.value !== '' });
    }
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.getValue() === nextProps.value;
  }

  onChange(e, { value }) {
    if (this.props.onChange) this.props.onChange(e);
    this.props.setValue(value);
  }

  onBlur(e) {
    this.setState({ initialBlur: true });
    if (this.props.onBlur) this.props.onBlur(e);
  }

  render() {
    const { name, showError, hasValue, validationError } = this.props;
    const hasError =
      (this.state.initialBlur || this.props.submitted) &&
      (showError() || (this.props.required && !hasValue()));
    const errorMessage = hasError ? validationError : null;

    const eventHandlers = {
      onChange: this.onChange,
      onBlur: this.onBlur
    };

    // Remove formsy props
    const { label, ..._rest } = _.omit(
      this.props,
      ...formsyProps
    );
    const margin = '0.25em';

    return (
      <div style={{ width: '100%' }}>
        {label && <div style={{ marginBottom: margin }}>
          <strong><label htmlFor={name}>{label}</label></strong>
        </div>}
        <Input
          {..._rest}
          {...eventHandlers}
        />
        <div className={styles.error} style={{ marginTop: margin }}>
          {errorMessage}
        </div>
      </div>
    );
  }
};

export default HOC(InputElement);



// WEBPACK FOOTER //
// ./webpack/components/Elements/Input/Input.js